import {date} from 'yup';

export const tablePurchaserStyle = {
	wrapper: {
		marginBottom: '24px',
	},

	title: {
		marginBottom: '12px',
		textTransform: 'capitalize',
	},

	content: {
		display: 'flex',
		gap: '12px',

		'@media (max-width: 767.98px)': {
			flexDirection: 'column',
		},
	},

	meals: {
		maxWidth: '200px',
		width: '100%',

		'@media (max-width: 767.98px)': {
			maxWidth: 'unset',
		},
	},

	names: {
		display: 'flex',
		gap: '12px',

		'@media (max-width: 767.98px)': {
			flexDirection: 'row',

			'& > div': {
				width: '50%',
			},
		},
	},

	data: {
		display: 'flex',
		gap: '12px',

		'@media (max-width: 639.98px)': {
			flexDirection: 'column',
		},

		'& > div': {
			width: '33%',

			'@media (max-width: 639.98px)': {
				width: '100%',
			},
		},
	},
};
